module.exports = __webpack_public_path__ + "static/media/link.f8ee1ed5.png";